// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__3saF1","time":"styles_time__2RI61"};